var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.selectableMolecule.selected ? 'white':'grey',"title":_vm.selectableMolecule.molecule.inchi},on:{"click":_vm.pressButton}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }